import classNames from 'classnames'
import { ROUTES } from 'constants/routes'
import useYearHandler from 'hooks/useYearHandler/useYearHandler'
import { useRouter } from 'next/router'
import Sidebar from 'organisms/sidebar'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

import useBreadcrumbs from './breadcrums'
import Navbar from './components/navbar/Navbar'
import AppLayoutSection from './organisms/appLayoutSection'

const AppLayout = ({ children }: AppLayoutProps) => {
  const { pathname } = useRouter()
  const [activeLink, setActiveLink] = useState<string>()
  const { isSidebarOpen } = useSelector((state: RootState) => state.app)
  const breadcrumbs = useBreadcrumbs()
  const isFullwidth = pathname === ROUTES.HOME

  useYearHandler()

  useEffect(() => {
    if (
      pathname.includes(ROUTES.USER_PROFILE) ||
      pathname === ROUTES.HOME ||
      pathname.includes(ROUTES.SETTINGS) ||
      pathname.includes(ROUTES.USER_ACCESS_MANAGEMENT)
    ) {
      setActiveLink(pathname)
    }
  }, [pathname])

  return (
    <div className="flex">
      {!isFullwidth && <Sidebar setActiveLink={setActiveLink} activeLink={activeLink} />}
      <div
        className={classNames('bg-blue900 min-h-screen overflow-y-hidden transition-width', {
          'w-[calc(100%-4.5rem)]': !isSidebarOpen && !isFullwidth,
          'w-[calc(100%-13.75rem)]': isSidebarOpen && !isFullwidth,
          'w-full': isFullwidth,
        })}>
        <div>
          <Navbar />
          <AppLayoutSection breadcrumbs={breadcrumbs} activeLink={activeLink}>
            {children}
          </AppLayoutSection>
        </div>
      </div>
    </div>
  )
}

interface AppLayoutProps {
  children: React.ReactNode
}

export default AppLayout
